import axios from 'axios';

function backendUrl() {
  return (process.env.NODE_ENV === 'development') ? 'http://localhost:3002' : process.env.PUBLIC_URL;
}

const backend = {
  get(url) { return axios.get(backendUrl() + url); },

  async getWithHeader(url, token) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(backendUrl() + url, { headers });
  },
};

export const ENVIRONMENT = '/environment';
export const ROLES = '/api/roles';

export default backend;
